import { lazy, Suspense } from 'react';

import { StockLtlEditProps, StockLtlEditDialogProps } from './types';

// Loaded on demand: only a Company Owner / Administrative user looking at a
// completed record ever needs the dialog, so the details screens keep their
// current imports (and bundle) for everyone else.
const StockOrderLtlEditInner = lazy(() =>
  import('./index').then((module) => ({ default: module.StockOrderLtlEdit }))
);
const StockTransferLtlEditInner = lazy(() =>
  import('./index').then((module) => ({
    default: module.StockTransferLtlEdit,
  }))
);

export const LazyStockOrderLtlEdit = (props: StockLtlEditProps) => (
  <Suspense fallback={null}>
    <StockOrderLtlEditInner {...props} />
  </Suspense>
);

export const LazyStockTransferLtlEdit = (props: StockLtlEditProps) => (
  <Suspense fallback={null}>
    <StockTransferLtlEditInner {...props} />
  </Suspense>
);

// T-F07: the dialog opened from the list row menu, loaded on first use.
const StockOrderLtlEditDialogInner = lazy(() =>
  import('./index').then((module) => ({
    default: module.StockOrderLtlEditDialog,
  }))
);
const StockTransferLtlEditDialogInner = lazy(() =>
  import('./index').then((module) => ({
    default: module.StockTransferLtlEditDialog,
  }))
);

export const LazyStockOrderLtlEditDialog = (props: StockLtlEditDialogProps) => (
  <Suspense fallback={null}>
    <StockOrderLtlEditDialogInner {...props} />
  </Suspense>
);

export const LazyStockTransferLtlEditDialog = (
  props: StockLtlEditDialogProps
) => (
  <Suspense fallback={null}>
    <StockTransferLtlEditDialogInner {...props} />
  </Suspense>
);
